import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import { Select } from '@material-ui/core';
import RxOrderContainer from '../../containers/RxOrder';

interface Props {
  meganetOptionItemId: number,
  leftMeganetLensMasterId: number,
  rightMeganetLensMasterId: number,
  meganetOptionMasterId: number,
  onChange: (meganetOptionItemId: number) => void,
}

export default ((props) => {
  const rxOrderContainer = RxOrderContainer.useContainer();
  const meganetOptionItemId = props.meganetOptionItemId || rxOrderContainer.getLeftOptionItemByOptionMasterId(props.leftMeganetLensMasterId, props.meganetOptionMasterId)[0].meganetOptionItemId;

  useEffect(() => {
    if (props.meganetOptionItemId === undefined) {
      props.onChange(meganetOptionItemId);
    }
  }, []);

  return (
    <Field style={{ fontSize: 13, }} required fullWidth name='option' label='Option' id='option' value={meganetOptionItemId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(Number(event.target.value))} component={Select} >
      <MenuItem style={{ height: 30, }} key={-1} value={-1}>--</MenuItem>
      // TODO Add TextField
      {props.meganetOptionMasterId !== 0
        ?
        rxOrderContainer.getLeftOptionItemByOptionMasterId(props.leftMeganetLensMasterId, props.meganetOptionMasterId).map(optionItem => (
          <MenuItem key={optionItem.meganetOptionItemId} value={optionItem.meganetOptionItemId}>{optionItem.optionItemName}</MenuItem>
        ))
        :
        <></>
      }
    </Field >
  );
}) as React.FC<Props>;
